import { IconBrush, IconFill, IconGlitter, IconSplash, IconPencil, IconMarker, IconSmudge, IconEyedropper, IconEraser, IconFlow } from './components/Icons'
import './MainTools.css'

const TOOLS = [
  { id: 'brush', label: { he: 'מברשת', en: 'Brush' }, title: { he: 'מברשת', en: 'Brush' }, Icon: IconBrush },
  { id: 'pencil', label: { he: 'עיפרון', en: 'Pencil' }, title: { he: 'עיפרון - קו דק ומדויק', en: 'Pencil - thin precise line' }, Icon: IconPencil },
  { id: 'marker', label: { he: 'מרקר', en: 'Marker' }, title: { he: 'מרקר - צבע שקוף', en: 'Marker - transparent color' }, Icon: IconMarker },
  { id: 'smudge', label: { he: 'מריחה', en: 'Smudge' }, title: { he: 'מריחה - לערבב צבעים', en: 'Smudge - blend colors' }, Icon: IconSmudge },
  { id: 'eraser', label: { he: 'מחק', en: 'Eraser' }, title: { he: 'מחק — מחזיר לדף לבן', en: 'Eraser — back to white paper' }, Icon: IconEraser },
  { id: 'fill', label: { he: 'מילוי', en: 'Fill' }, title: { he: 'מילוי אזור', en: 'Fill area' }, Icon: IconFill },
  { id: 'glitter', label: { he: 'נצנצים', en: 'Glitter' }, title: { he: 'נצנצים', en: 'Glitter' }, Icon: IconGlitter },
  {
    id: 'splash',
    label: { he: 'זריקת צבע', en: 'Splash' },
    title: {
      he: 'זריקת צבע עם ספלאש (בדפדפן בלבד) — לחצו על הדף',
      en: 'Paint splash (web only) — tap the page',
    },
    Icon: IconSplash,
  },
  { id: 'eyedropper', label: { he: 'בודק צבע', en: 'Pick color' }, title: { he: 'לחצו על הציור לבחירת צבע', en: 'Click the drawing to pick a color' }, Icon: IconEyedropper },
  { id: 'measure', label: { he: 'מדידה', en: 'Measure' }, title: { he: 'מדידה על גבי התמונה (שתי נקודות)', en: 'Measure on photo (two points)' }, Icon: IconFill },
  {
    id: 'flow',
    label: { he: 'תרשים זרימה', en: 'Flow' },
    title: {
      he: 'תרשים זרימה (Excalidraw) — צורות, טקסט, מחק; בפאנל: ייצוא PDF/תמונה',
      en: 'Flow chart (Excalidraw-style) — shapes, text, erase; panel: export PDF/image',
    },
    Icon: IconFlow,
  },
]

const EASY_TOOLS = ['brush', 'eraser', 'fill', 'glitter', 'splash', 'eyedropper']

export function MainTools({ tool, setTool, expertMode, lang = 'he', webPaintSplash = false }) {
  const tools = (expertMode ? TOOLS : TOOLS.filter((t) => EASY_TOOLS.includes(t.id))).filter(
    (t) => t.id !== 'splash' || webPaintSplash,
  )
  return (
    <div className={`main-tools ${!expertMode ? 'easy-mode' : ''}`}>
      {tools.map(({ id, label, title, Icon }) => (
        <button
          key={id}
          type="button"
          className={`main-tool-btn ${tool === id ? 'active' : ''}`}
          onClick={() => setTool(id)}
          title={(title?.[lang] || title?.he || '')}
        >
          <span className="main-tool-icon"><Icon size={20} /></span>
          <span className="main-tool-label">{(label?.[lang] || label?.he || '')}</span>
        </button>
      ))}
    </div>
  )
}
